import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { TpButtonModule } from 'app/components/tp-button/tp-button.module';
import { TpEmailComposerModule } from 'app/components/tp-email-composer/tp-email-composer.module';
import { TpEmailContentFormModule } from 'app/components/tp-email-content-form/tp-email-content-form.module';
import { TpMergeTagChipsModule } from 'app/components/tp-merge-tag-chips/tp-merge-tag-chips.module';
import { TpTextBoxModule } from 'app/components/tp-text-box/tp-text-box.module';
import { FormatDatePipeModule } from 'app/pipes/format-date/format-date-pipe.module';
import { LeadFollowUpFormComponent } from './lead-followup-form/lead-followup-form.component';
import { LeadFollowUpRowComponent } from './lead-followup-row/lead-followup-row.component';

@NgModule({
    declarations: [
        LeadFollowUpFormComponent,
        LeadFollowUpRowComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        TranslateModule,
        TpButtonModule,
        TpEmailComposerModule,
        TpEmailContentFormModule,
        TpMergeTagChipsModule,
        TpTextBoxModule,
        FormatDatePipeModule,
    ],
    exports: [
        LeadFollowUpFormComponent,
        LeadFollowUpRowComponent,
    ],
})
export class LeadFollowUpModule {}
